import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import GaugeComparisonChart from "../charts/generic/GaugeComparisonChart"

function LengthOfServiceAverage({ exportEndpoint, appliedFilters, data, sampleSize }) {
  const titleKey="Widgets.LengthOfServiceAverage.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.AvgLengthOfService.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      sampleSize={sampleSize}
    >
      <GaugeComparisonChart
        data={data}
        labelText="Widgets.LengthOfServiceAverage.Label"
        singularLabelText="Widgets.LengthOfServiceAverage.SingularLabel"
        reverseLegend
        titleKey={titleKey}
      />
    </Widget>
  )
}

LengthOfServiceAverage.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  sampleSize: PropTypes.object
}

export default LengthOfServiceAverage



// WEBPACK FOOTER //
// ./src/components/widgets/LengthOfServiceAverage.jsx